<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="emitClose">
    <q-card style="width: 420px; max-width: 90vw; padding: 16px">

      <c-modal-title
        propModalTitle="Filtro de PCs"
        propModalDescription="Pesquise e filtre por PCs"
      />

      <div class="row">
        <div class="col-12">

          <div class="q-mb-sm">
            <div class="text-caption q-mb-xs">Código do PC</div>
            <q-input v-model="pcStore.pcFilter.filterPc.codpontocaptura" outlined dense class="full-width" />
          </div>

          <div class="q-mb-sm">
            <div class="text-caption q-mb-xs">Nome do PC</div>
            <q-input v-model="pcStore.pcFilter.filterPc.nompontocaptura" outlined dense class="full-width" />
          </div>

          <div class="q-mb-sm">
            <div class="text-caption q-mb-xs">Cidade</div>
            <q-select v-model="pcStore.pcFilter.filterPc.nomcidredeautoatndto" :options="cidadeOptions" outlined dense clearable class="full-width" />
          </div>

          <div class="q-mb-sm">
            <div class="text-caption q-mb-xs">UF</div>
            <q-select v-model="pcStore.pcFilter.filterPc.ufredeautoatndto" :options="ufOptions" outlined dense clearable class="full-width" />
          </div>

          <div class="q-mb-sm">
            <div class="text-caption q-mb-xs">Rede</div>
            <q-input :model-value="redeLabel" outlined dense readonly class="full-width" />
          </div>

          <div class="q-mb-sm">
            <div class="text-caption q-mb-xs">Subrede</div>
            <q-select
              v-model="pcStore.pcFilter.filterPc.codsubredeautoatndto"
              :options="subredeOptions"
              option-value="value"
              option-label="label"
              emit-value
              map-options
              multiple
              readonly
              outlined dense clearable class="full-width"
            />
          </div>

          <div class="q-mb-sm">
            <div class="text-caption q-mb-xs">Segmento</div>
            <q-select v-model="pcStore.pcFilter.filterPc.nomsegmmerclocalptoatndto" :options="segmentoOptions" outlined dense clearable class="full-width" />
          </div>

          <div class="q-mb-sm">
            <div class="text-caption q-mb-xs">Tipo Máquina</div>
            <q-select v-model="pcStore.pcFilter.filterPc.nomtpmaqautoatndto" :options="tipoMaquinaOptions" outlined dense clearable class="full-width" />
          </div>

          <div class="row q-gutter-sm q-pt-md">
            <c-q-btn propBtnLabel="Importar PCs" :propBtnSize="EnumButtonSizes.LARGE_1" @click="triggerFileUpload" />
            <c-q-btn propBtnLabel="Buscar" :propBtnSize="EnumButtonSizes.LARGE_1" @click="onFetchBtnClick" />
            <c-q-btn propBtnLabel="Continuar" :propBtnSize="EnumButtonSizes.LARGE_1" @click="onContinueBtnClick" />
          </div>

        </div>
      </div>

      <input type="file" accept=".csv" id="file-upload" style="display: none" @change="onFileChangeAndUpload" />

    </q-card>
  </q-dialog>

  <ModalPCsInstitutional />
</template>

<script setup lang="ts">
import { EnumButtonSizes } from "@/enums/enums"
import { usePCStore } from "@/stores/pcStore"
import { usePagesUtilStore } from "@/stores/pagesUtilStore"
import { ref, computed, watch, onMounted } from "vue"
import ModalPCsInstitutional from "./ModalPCsInstitutional.vue"
import { useRedeSubredeStore } from "@/stores/redeSubredeStore"

const pcStore = usePCStore()
const pagesUtilStore = usePagesUtilStore()
const redeSubredeStore = useRedeSubredeStore()

defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ (e: 'update:modelValue', value: boolean): void }>()

onMounted(async () => {
  await pcStore.fetchPCs(0, 100000)
})

/* =======================
 * OPTIONS DINÂMICOS
 * ======================= */
//const cidadeOptions = computed(() => [...new Set(pcStore.pcs.map(p => p.nomcidredeautoatndto))].filter(Boolean));
//const ufOptions = computed(() => [...new Set(pcStore.pcs.map(p => p.ufredeautoatndto))].filter(Boolean));

const pcsParaFiltro = computed(() => {
  const subredesSelecionadas =
    redeSubredeStore.subredesSelecionadas

  if (!subredesSelecionadas?.length) {
    return pcStore.pcs
  }

  return pcStore.pcs.filter(pc =>
    subredesSelecionadas.some(
      s => s.nomSubredeAutoAtndto === pc.nomsubredeautoatndto
    )
  )
})

const cidadeOptions = computed(() =>
  [...new Set(
    pcsParaFiltro.value
      .map(p => p.nomcidredeautoatndto)
      .filter((v): v is string => !!v)
  )]
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
)

const ufOptions = computed(() =>
  [...new Set(
    pcsParaFiltro.value
      .map(p => p.ufredeautoatndto)
      .filter((v): v is string => !!v)
  )]
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
)

const segmentoOptions = computed(() =>
  [...new Set(
    pcsParaFiltro.value
      .map(p => p.nomsegmmerclocalptoatndto)
      .filter((v): v is string => !!v)
  )]
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
)

const tipoMaquinaOptions = computed(() =>
  [...new Set(
    pcsParaFiltro.value
      .map(p => p.nomtpmaqautoatndto)
      .filter((v): v is string => !!v)
  )]
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
)


// ✅ CORRETO - options com label e value
const subredeOptions = computed(() => {
  if (redeSubredeStore.subredesSelecionadas.length > 0) {
    return redeSubredeStore.subredesSelecionadas.map(s => ({
      label: s.nomSubredeAutoAtndto,
      value: s.codSubredeAutoAtndto // ✅ já é number, sem conversão
    }));
  }

  return [...new Set(pcStore.pcs.map(p => p.nomsubredeautoatndto))]
    .filter(Boolean)
    .map(nome => {
      const pc = pcStore.pcs.find(p => p.nomsubredeautoatndto === nome);
      return {
        label: nome,
        value: pc?.codsubredeautoatndto // ✅ já é number
      };
    });
});

//const segmentoOptions = computed(() => [...new Set(pcStore.pcs.map(p => p.nomsegmmerclocalptoatndto))].filter(Boolean));
//const tipoMaquinaOptions = computed(() => [...new Set(pcStore.pcs.map(p => p.nomtpmaqautoatndto))].filter(Boolean));

const redeLabel = computed(() => "Banco24Horas");


/* =======================
 * BOTÕES
 * ======================= */
const onFetchBtnClick = async () => {
  await pcStore.fetchPCs(0, 10)

  pagesUtilStore.showModalFilterPCs = false
  pagesUtilStore.showModalPCsInstitutional = true
}

/* ✅ AQUI ESTÁ O PONTO MAIS IMPORTANTE */

const onContinueBtnClick = () => {
  emit('update:modelValue', false)
};

/* =======================
 * CSV
 * ======================= */
const triggerFileUpload = () => {
  document.getElementById("file-upload")?.click();
};

const onFileChangeAndUpload = async (event: Event) => {
  const input = event.target as HTMLInputElement;

  if (input.files && input.files[0]) {
    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = async (e) => {
      const csv = e.target?.result as string;
      const ids = csv.split("\n").slice(1).map(r => r.split(",")[0].trim());

      pcStore.pcFilter.filterPc.codpontocaptura = ids;
      await pcStore.fetchPCs(0, 10, ids);
    };

    reader.readAsText(file);
  }
};

const emitClose = (val: boolean) => {
  emit('update:modelValue', val);
};

watch(
  () => redeSubredeStore.subredesSelecionadas,
  (subredes) => {
    if (subredes.length > 0) {
      pcStore.pcFilter.filterPc.codsubredeautoatndto =
        subredes.map(s => s.codSubredeAutoAtndto)
    }
  },
  { immediate: true }
)

</script>